(() => {
  const CONTROLLER_FLAG = 'data-hormonize-benefits-js-ready';
  const BENEFITS_SELECTOR = '.hormonize-benefits';
  const CAROUSEL_SELECTOR = '[data-hormonize-benefits-carousel]';

  const instances = new WeakMap();

  class HormonizeBenefitsController {
    constructor(section) {
      this.section = section;
      this.carousel = section.querySelector(CAROUSEL_SELECTOR);
      this.carouselController = null;

      if (this.carousel && window.HormonizeScrollCarouselController) {
        this.carouselController = new window.HormonizeScrollCarouselController(this.carousel, {
          viewportSelector: '.hormonize-benefits__viewport',
          itemSelector: '.hormonize-benefits__item',
          paginationSelector: '[data-hormonize-benefits-pagination]',
          prevSelector: '[data-hormonize-benefits-prev]',
          nextSelector: '[data-hormonize-benefits-next]',
          statusSelector: '.hormonize-benefits__sr-status',
          dotClassName: 'hormonize-benefits__dot',
          singleClassName: 'is-single',
          alwaysActive: true,
          snapAlign: 'responsive',
          slideNoun: 'benefit',
          slideLabel: 'Benefit',
          getSlideTitle: (item) =>
            item.querySelector('.hormonize-benefits__card-title')?.textContent?.trim() || '',
        });
        this.carouselController.init();
      }
    }

    destroy() {
      this.carouselController?.destroy();
      this.carouselController = null;
      this.section = null;
      this.carousel = null;
    }
  }

  function initBenefits(section) {
    if (!(section instanceof HTMLElement) || !section.matches(BENEFITS_SELECTOR) || instances.has(section)) {
      return;
    }

    instances.set(section, new HormonizeBenefitsController(section));
  }

  function initBenefitsSections(root = document) {
    const searchRoot = root instanceof Element || root instanceof Document ? root : document;

    if (searchRoot instanceof Element && searchRoot.matches(BENEFITS_SELECTOR)) {
      initBenefits(searchRoot);
    }

    searchRoot.querySelectorAll(BENEFITS_SELECTOR).forEach(initBenefits);
  }

  function destroyBenefitsSections(root) {
    const searchRoot = root instanceof Element ? root : document;
    const sections = [];

    if (searchRoot instanceof Element && searchRoot.matches(BENEFITS_SELECTOR)) {
      sections.push(searchRoot);
    }

    searchRoot.querySelectorAll(BENEFITS_SELECTOR).forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      const instance = instances.get(section);

      if (!instance) {
        return;
      }

      instance.destroy();
      instances.delete(section);
    });
  }

  function onSectionLoad(event) {
    initBenefitsSections(event.target);
  }

  function onSectionUnload(event) {
    destroyBenefitsSections(event.target);
  }

  function bindLifecycleEvents() {
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:section:reorder', () => {
      destroyBenefitsSections(document);
      initBenefitsSections(document);
    });
  }

  if (!document.documentElement.hasAttribute(CONTROLLER_FLAG)) {
    document.documentElement.setAttribute(CONTROLLER_FLAG, '');
    bindLifecycleEvents();
  }

  initBenefitsSections(document);
})();
